module.exports = __webpack_public_path__ + "img/img-skin01.71c8fb6c.jpg";